export default (props = {}) => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="Play">
<path id="Play icon" fill-rule="evenodd" clip-rule="evenodd" d="M16.8271 8.84657L6.05254 2.19135C5.1553 1.64801 4 2.32638 4 3.41309V16.5869C4 17.6736 5.15382 18.352 6.05254 17.8087L16.8271 11.1534C17.7243 10.7467 17.7243 9.38835 16.8271 8.84501V8.84657Z" fill="#EEEEEE"/>
</g>
</svg>
